/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-12-01 14:55:52
 * @LastEditors: jiayi zhu
 */
export default {
  Columbus: 'https://columbus.boohee.com',
  PixiuHost: 'https://pixiu.boohee.com',
  PayersHost: 'https://payers.boohee.com',
  SEAFARER_HOST: 'https://seafarer.boohee.com/',
  ONE_HOST: 'https://one.boohee.com/',
  STATUS_HOST: 'https://status.boohee.com/',
  APP_INTER_HOST: 'https://api.boohee.com/',
  API_HOST: 'https://api.boohee.com/',
  TOOLKIT_HOST: 'https://toolkit.boohee.com/',
  SA_SERVER_URL: 'https://saapi.boohee.cn/sa?project=production',
  REPORT_URL: 'https://front-report.boohee.cn/open-interface/v1/base/front-log-report'
};
